<div [ngSwitch]="field?.appearance">
  <relation-checkbox *ngSwitchCase="'checkbox'" [field]="field" [formGroup]="formGroup"></relation-checkbox>
  <combobox-multiple *ngSwitchDefault [field]="field" [formGroup]="formGroup"></combobox-multiple>
</div>
